<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.reservation && wrapper">
  <app-popup-header title="{{localService.languageContent.reservation.header}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row" *ngIf="groupTitles.length > 0">
      <div class="col-5">
        <app-label [Text]="localService.languageContent.reservation.groups"></app-label>
      </div>
      <div class="col-6">
        <ngx-select [(ngModel)]="wrapper.key" [noAutoComplete]="true" [items]="groupTitles" [optionValueField]="'key'" [optionTextField]="'v1'" (select)="onAction(1)" placeholder="{{localService.languageContent.reservation.select_group}}">
          <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
            <div class="row" title="{{option.data.v1}}">
              <div class="col-12">
                <span class="en">{{option.data.v1}}</span>
              </div>
            </div>
          </ng-template>
        </ngx-select>
      </div>
      <div class="col-1">
        <i class="material-icons icon_adjust" style="float:right;" (click)="onReset()" *ngIf="wrapper.key != undefined && wrapper.key != null && wrapper.key != ''">add_circle_outline</i>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <app-label [Text]="localService.languageContent.reservation.group_code"></app-label>
      </div>
      <div class="col-4" style="text-align:left">
        <input id="{{elementIds.seat_code}}" autocomplete="off" type="text" maxlength="10" [(ngModel)]="wrapper.v1" [ngClass]="wrapper.v1 != '' ? 'en': ''" title="{{localService.languageContent.reservation.ph_group_code}}" placeholder="{{localService.languageContent.reservation.ph_group_code}}" (keydown.enter)="onAction(7)" />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <app-label [Text]="localService.languageContent.reservation.num_seats" [IsMandatory]="true"></app-label>
      </div>
      <div class="col-4" style="text-align:left">
        <input id="{{elementIds.seat_cnt}}" autocomplete="off" type="number" class="number" (keypress)="localService.isNumberOnly($event)" min="1" [(ngModel)]="wrapper.v4" [ngClass]="wrapper.v4 != null ? 'en': ''" title="{{localService.languageContent.reservation.ph_seat_num}}" placeholder="{{localService.languageContent.reservation.ph_seat_num}}" (keydown.enter)="onAction(6)" />
      </div>
    </div>
    <div class="row" *ngIf="message != ''">
      <div class="col-12" style="text-align:center;">
        <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
      </div>      
    </div>
    <div class="row">
      <div class="col-7">
        <label style="margin-left: 15px;font-weight:normal;">
          <input type="checkbox" [(ngModel)]="wrapper.isSelected">
          <span style="color:darkslategrey">{{localService.languageContent.reservation.is_active}}</span>
        </label>
      </div>
      <div class="col-5" style="text-align:right;">
        <button id="{{elementIds.seat_save}}" type="button" class="btn btn-primary" (click)="onPopupSave()">{{ !wrapper.key || wrapper.key == '' ? localService.languageContent.common.add : localService.languageContent.common.update}}</button>
      </div>
    </div>
    <div class="dummy">
      &nbsp;
    </div>
    <div *ngIf="wrapper.key && wrapper.key != ''" class="box">
      <div class="row">
        <div class="col-12">
          <app-seat-arrangements [seatsStatusAndTitle]="seatsStatusAndTitle" [seatType]="seatType" [isDark]="false"></app-seat-arrangements>
        </div>
      </div>      
      <div class="row">
        <app-label [Text]="localService.languageContent.reservation.seats"></app-label>
      </div>
      <div class="row" *ngFor="let item of seats">
        <div class="col-3">
          &nbsp;
        </div>
        <div class="col-1">
          <i class="material-icons button icon_adjust" title="{{item.isSelected ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onAction(2,item.key)" [ngStyle]="{'color': item.isSelected ? 'yellowgreen' : 'orangered' }">{{item.isSelected ? "toggle_on" : "toggle_off"}}</i>
        </div>
        <div class="col-4">
          <input autocomplete="off" type="text" maxlength="10" [(ngModel)]="item.v1" [ngClass]="item.v1 != '' ? 'en': ''" title="{{localService.languageContent.reservation.ph_group_code}}" (keydown.enter)="onAction(4,item.key)" (blur)="onAction(4,item.key)" placeholder="{{localService.languageContent.reservation.ph_group_code}}" />
        </div>
        <div class="col-1">
          <i class="material-icons delete_icon action_icon" (click)="onAction(3,item.key)">{{item.v2 == '0' ? 'cancel' : 'undo'}}</i>
        </div>
        <div class="col-3">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</div>
